import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loadingShow", "loadingHide", "contentLoaded", "loadingDisable"]

  showLoading() {
    this.toggleLoading(true)
  }

  hideLoading() {
    this.toggleLoading(false)
  }

  contentLoadedTargetConnected() {
    this.hideLoading()
  }

  toggleLoading(show) {
    this.loadingShowTargets.forEach(target => {
      target.classList.toggle("hide", !show)
      target.classList.toggle("hidden", !show)
    })
    this.loadingDisableTargets.forEach(target => {
      target.disabled = true
    })
    this.loadingHideTargets.forEach(target => {
      target.classList.toggle("hide", show)
      target.classList.toggle("hidden", show)
    })
  }
}
